import React from 'react';
import ScreenStreamPage from './screen-stream-page';

const StreamPage: React.FC = () => <ScreenStreamPage />;

export default StreamPage;
